import { StyleSheet } from "react-native";
import Metrics from "../../../../Theme/Metrics";

export const homeLiveCardStyles = StyleSheet.create({
    cover: {
        marginBottom: Metrics.verticalScale(11)
    }
})